export default "__VITE_ASSET__jqQ$BSNG__"